export default __webpack_public_path__ + "static/media/2cc2bbf6db68b107.5681a726edb2154f1b2ff6b0ac6bc3e8.svg";